module.exports = __webpack_public_path__ + "img/hr-tree-05-a-trunk.3ab562d3.png";